module.exports = __webpack_public_path__ + "img/brand-cases6.78d389db.png";